/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DocumentWithContentMetadata =
  | string
  | number
  | number
  | boolean
  | Array<string>;

export type DocumentWithContent = {
  status: string;
  id: string;
  createdAt: Date;
  updatedAt: Date;
  name: string;
  metadata: { [k: string]: string | number | number | boolean | Array<string> };
  partition: string;
  chunkCount?: number | null | undefined;
  externalId?: string | null | undefined;
  pageCount?: number | null | undefined;
  content: string;
};

/** @internal */
export const DocumentWithContentMetadata$inboundSchema: z.ZodType<
  DocumentWithContentMetadata,
  z.ZodTypeDef,
  unknown
> = z.union([
  z.string(),
  z.number().int(),
  z.number(),
  z.boolean(),
  z.array(z.string()),
]);
/** @internal */
export type DocumentWithContentMetadata$Outbound =
  | string
  | number
  | number
  | boolean
  | Array<string>;

/** @internal */
export const DocumentWithContentMetadata$outboundSchema: z.ZodType<
  DocumentWithContentMetadata$Outbound,
  z.ZodTypeDef,
  DocumentWithContentMetadata
> = z.union([
  z.string(),
  z.number().int(),
  z.number(),
  z.boolean(),
  z.array(z.string()),
]);

export function documentWithContentMetadataToJSON(
  documentWithContentMetadata: DocumentWithContentMetadata,
): string {
  return JSON.stringify(
    DocumentWithContentMetadata$outboundSchema.parse(
      documentWithContentMetadata,
    ),
  );
}
export function documentWithContentMetadataFromJSON(
  jsonString: string,
): SafeParseResult<DocumentWithContentMetadata, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DocumentWithContentMetadata$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DocumentWithContentMetadata' from JSON`,
  );
}

/** @internal */
export const DocumentWithContent$inboundSchema: z.ZodType<
  DocumentWithContent,
  z.ZodTypeDef,
  unknown
> = z.object({
  status: z.string(),
  id: z.string(),
  created_at: z.string().datetime({ offset: true }).transform(v => new Date(v)),
  updated_at: z.string().datetime({ offset: true }).transform(v => new Date(v)),
  name: z.string(),
  metadata: z.record(
    z.union([
      z.string(),
      z.number().int(),
      z.number(),
      z.boolean(),
      z.array(z.string()),
    ]),
  ),
  partition: z.string(),
  chunk_count: z.nullable(z.number().int()).optional(),
  external_id: z.nullable(z.string()).optional(),
  page_count: z.nullable(z.number()).optional(),
  content: z.string(),
}).transform((v) => {
  return remap$(v, {
    "created_at": "createdAt",
    "updated_at": "updatedAt",
    "chunk_count": "chunkCount",
    "external_id": "externalId",
    "page_count": "pageCount",
  });
});
/** @internal */
export type DocumentWithContent$Outbound = {
  status: string;
  id: string;
  created_at: string;
  updated_at: string;
  name: string;
  metadata: { [k: string]: string | number | number | boolean | Array<string> };
  partition: string;
  chunk_count?: number | null | undefined;
  external_id?: string | null | undefined;
  page_count?: number | null | undefined;
  content: string;
};

/** @internal */
export const DocumentWithContent$outboundSchema: z.ZodType<
  DocumentWithContent$Outbound,
  z.ZodTypeDef,
  DocumentWithContent
> = z.object({
  status: z.string(),
  id: z.string(),
  createdAt: z.date().transform(v => v.toISOString()),
  updatedAt: z.date().transform(v => v.toISOString()),
  name: z.string(),
  metadata: z.record(
    z.union([
      z.string(),
      z.number().int(),
      z.number(),
      z.boolean(),
      z.array(z.string()),
    ]),
  ),
  partition: z.string(),
  chunkCount: z.nullable(z.number().int()).optional(),
  externalId: z.nullable(z.string()).optional(),
  pageCount: z.nullable(z.number()).optional(),
  content: z.string(),
}).transform((v) => {
  return remap$(v, {
    createdAt: "created_at",
    updatedAt: "updated_at",
    chunkCount: "chunk_count",
    externalId: "external_id",
    pageCount: "page_count",
  });
});

export function documentWithContentToJSON(
  documentWithContent: DocumentWithContent,
): string {
  return JSON.stringify(
    DocumentWithContent$outboundSchema.parse(documentWithContent),
  );
}
export function documentWithContentFromJSON(
  jsonString: string,
): SafeParseResult<DocumentWithContent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DocumentWithContent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DocumentWithContent' from JSON`,
  );
}
